import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import AuthReducer from "./auth/AuthReducer.js";
import NotificationsReducer from "./notificationsSlice.js";
import RelayReducer from "./relaysSlice.js";
import SiteReducer from "./sitesSlice.js";
import PanelsReducer from "./panelsSlice.js";
import RealtimeReducer from "./realtimeSlice.js";
import ConnectionReducer from "./connectionSlice.js";
import EventsReducer from "./eventsSlice.js";


//REDUX-DEVTOOLS
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    combineReducers(
        {
            sites: SiteReducer, // Site manager

            panels: PanelsReducer,
            
            realtime: RealtimeReducer, // Realtime data feed.

            auth: AuthReducer, //JWT list
            events: EventsReducer, //Events list
            notifications: NotificationsReducer,
            
            relays: RelayReducer,
            connection: ConnectionReducer
        }
    ),
    composeEnhancers(applyMiddleware(thunk))
);

store.subscribe(() => {
    if (localStorage.getItem("AuthData") != store.getState().auth.session) {
        localStorage.setItem("AuthData", store.getState().auth.session);
    }
})

window._store = store;

export default store;